import React, { Component } from 'react';
import clorianLogo from '../../resources/images/Clorian.svg';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import history from '../../history';
import { connect } from 'react-redux';
import AffiliateHeaderContainer from '../../containers/AffiliateHeaderContainer';
import { cleanAffiliateList } from "../../actions/affiliates";

class Header extends Component {

  constructor(props) {
    super(props);
    this.logout = this.logout.bind(this);
  }

  logout(){
    const {dispatch} = this.props;
    dispatch(cleanAffiliateList());

    localStorage.clear();
    history.push('/');
  };


  render() {
    return (
      <header>
        <div className="header">
          <div className="header-brand">
            <img src={clorianLogo} alt="logo" />
          </div>

          <div className="header-title">
            <div className="actions">
              <DropdownButton title="Menu" id={`dropdown-basic`}>
                <MenuItem eventKey="1" onClick={this.logout}>
                  <span className="glyphicon glyphicon-log-out" /> Logout
                </MenuItem>
              </DropdownButton>
            </div>
            <AffiliateHeaderContainer />
          </div>
        </div>
      </header>
    );
  }
}

export default connect()(Header);
